import { render, staticRenderFns } from "./SiseriUploader.vue?vue&type=template&id=36ba8764&"
import script from "./SiseriUploader.vue?vue&type=script&lang=js&"
export * from "./SiseriUploader.vue?vue&type=script&lang=js&"
import style0 from "./SiseriUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports